import React from 'react';
import { Icon, Text } from 'components/common';
import { getTextContent } from 'utils/string';
import { AccordionItem as Item, AccordionTitle } from './Accordion.styled';

import AccordionContent from './AccordionContent';

type AccordionItemProps = {
  content: any;
  inverted: boolean;
  renderActiveItem: boolean;
};

type AccordionItemState = {
  isActiveItem: any;
};

class AccordionItem extends React.PureComponent<AccordionItemProps, AccordionItemState> {
  constructor(props: AccordionItemProps) {
    super(props);
    this.state = {
      isActiveItem: undefined
    };
  }

  toggle() {
    const { renderActiveItem } = this.props;
    const { isActiveItem } = this.state;
    if (isActiveItem !== undefined) {
      this.setState({ isActiveItem: !isActiveItem });
    } else {
      this.setState({ isActiveItem: !renderActiveItem });
    }
  }

  render() {
    const { inverted, content, renderActiveItem } = this.props;
    const { value, children } = content;
    const { isActiveItem } = this.state;
    const isActive = isActiveItem !== undefined ? isActiveItem : renderActiveItem;
    return (
      <Item>
        <AccordionTitle className={isActive ? 'active' : ''} onClick={() => this.toggle()}>
          <Text appearance="h4" size={18}>
            {getTextContent(value)}
          </Text>
          <Icon name="accordion-arrow" />
        </AccordionTitle>
        <AccordionContent
          height={isActive ? 'auto' : 0}
          content={value}
          childrenElements={children}
          inverted={inverted}
        ></AccordionContent>
      </Item>
    );
  }
}

export default AccordionItem;
